import { makeAutoObservable } from "mobx";
import { KeyValueListPerDb } from "../Models/KeyValueListPerDb";
import { KeyValue } from "../Models/KeyValue";

export class TempStore {
  private _orderGroupList: KeyValueListPerDb | null = null;
  private _boxList: KeyValueListPerDb | null = null;

  constructor() {
    makeAutoObservable(this);
  }
  public clear(): void {
    this._orderGroupList = null;
    this._boxList = null;
  }
  public get orderGroupList(): KeyValueListPerDb | null {
    return this._orderGroupList;
  }

  public set orderGroupList(value: KeyValueListPerDb | null) {
    this._orderGroupList = value;
  }

  public getOrderGroupList(serverUrl: string, dbKey: string): KeyValue[] {
    if (this._orderGroupList && this._orderGroupList.serverUrl === serverUrl && this._orderGroupList.dbKey === dbKey) {
      return this._orderGroupList.keyValueList;
    }
    return [];
  }

  public setOrderGroupList(serverUrl: string, dbKey: string, keyValueList: KeyValue[]): void {
    this._orderGroupList = {
      serverUrl,
      dbKey,
      keyValueList,
    };
  }

  public get boxList(): KeyValueListPerDb | null {
    return this._boxList;
  }

  public set boxList(value: KeyValueListPerDb | null) {
    this._boxList = value;
  }

  public getBoxList(serverUrl: string, dbKey: string): KeyValue[] {
    if (this._boxList && this._boxList.serverUrl === serverUrl && this._boxList.dbKey === dbKey) {
      return this._boxList.keyValueList;
    }
    return [];
  }

  public setBoxList(serverUrl: string, dbKey: string, keyValueList: KeyValue[]): void {
    this._boxList = {
      serverUrl,
      dbKey,
      keyValueList,
    };
  }
}

const tempStore = new TempStore();
export default tempStore;
